import gql from 'graphql-tag';

import { address, lectureInstance, officePlace } from '../fragments';

export const createOfficePlace = gql`
    mutation CreateOfficePlace($input: CreateOfficePlaceInput!) {
        createOfficePlace(input: $input) {
            ...OfficePlaceFragment
            address {
                ...AddressFragment
            }
        }
    }
    ${officePlace}
    ${address}
`;

export const updateOfficePlaceById = gql`
    mutation UpdateOfficePlaceById($officeId: Int!, $placeId: Int!, $input: UpdateOfficePlaceInput!) {
        updateOfficePlaceById(officeId: $officeId, placeId: $placeId, input: $input) {
            ...OfficePlaceFragment
            address {
                ...AddressFragment
            }
        }
    }
    ${officePlace}
    ${address}
`;

export const deleteOfficePlaceById = gql`
    mutation DeleteOfficePlaceById($officeId: Int!, $placeId: Int!, $transferPlaceId: Int) {
        deleteOfficePlaceById(officeId: $officeId, placeId: $placeId, transferPlaceId: $transferPlaceId) {
            success
            updatedLectureInstances {
                ...LectureInstanceFragment
                place {
                    ...OfficePlaceFragment
                }
            }
        }
    }
    ${lectureInstance}
    ${officePlace}
`;
